module.exports = __webpack_public_path__ + "static/media/flria shot 15.2d3ca75c.webp";